export enum PromotionPublishedEnum {
  NOW = 'NOW',
  PERIOD = 'PERIOD',
}
